// removed by extract-text-webpack-plugin
module.exports = {"homeBtn":"_2LWtmMMqWRfAndCXF9WdEe"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlist/components/PlaylistHomeButton/PlaylistHomeButton.scss
// module id = 1360
// module chunks = 1